import { useEffect, useState } from 'react';

import { FileDescriptor } from '@dreryk/command-query-ws-api';

import { StyledHealthcareInstitutionLogo } from './HealthcareInstitutionLogo.styled';
import { StyledHealthcareInstitutionLogoImage } from './HealthcareInstitutionLogoImage.styled';

type HealthcareInstitutionLogoSvgProps = {
   readonly fileDescriptor: FileDescriptor;
};

export const HealthcareInstitutionLogoSvg = (props: HealthcareInstitutionLogoSvgProps): JSX.Element => {
   const [svgBase64, setSvgBase64] = useState<string | undefined>();

   useEffect(() => {
      const reader = new FileReader();

      reader.onload = (e) => {
         const svgText = e.target!.result;
         setSvgBase64(svgText as string);
      };

      reader.readAsDataURL(props.fileDescriptor.file!);

      return () => {
         if (reader.readyState === FileReader.LOADING) {
            reader.abort();
         }
      };
   }, [props.fileDescriptor]);

   return (
      <StyledHealthcareInstitutionLogo justifyContent={'center'} alignItems={'center'}>
         <StyledHealthcareInstitutionLogoImage src={svgBase64} />
      </StyledHealthcareInstitutionLogo>
   );
};
